import { TFunction } from "react-i18next";
import { convertUTCDateToLocalDate } from "go-core/components/Formatters/FormatDate";
import { OrganizationAlert } from "../../../../../../services/Api/Organization/organizationTypes";
import {
	getLicenseExpirationAlert,
	getLicensePaymentDueAlert,
	getManualLicenseAlert,
} from "../../../Organization/utils";

export const getLicensePaymentDueDays = (paymentDateDue: string, organizationTimezone?: string) => {
	return (
		Math.floor(
			(convertUTCDateToLocalDate(paymentDateDue, organizationTimezone).getTime() - new Date().getTime()) /
				86400000
		) + 1
	);
};

export const getTerminalVersionStatusAlert = (t: TFunction, isOutdated?: boolean, isTestVersion?: boolean) => {
	const alerts: OrganizationAlert[] = [];
	if (isOutdated) {
		alerts.push({
			title: `${t("modules.organization.field.terminal_outdated.title", { ns: "admin" })}`,
			type: "WARNING",
		});
	}
	if (isTestVersion) {
		alerts.push({
			title: `${t("modules.organization.field.terminal_test_version.title", { ns: "admin" })}`,
			type: "DANGER",
		});
	}

	return alerts;
};

export const getOrganizationAlerts = (
	licenseExpiresAt: string,
	licenseType: string,
	paymentDueDate: string,
	t: TFunction,
	isAdminMode: boolean,
	abusedAccesses: number,
	outdatedTerminals?: number,
	testVersionTerminals?: number,
	organizationTimezone?: string
): OrganizationAlert[] => {
	const licenseExpirationAlert = getLicenseExpirationAlert(t, licenseExpiresAt, licenseType, organizationTimezone);
	const licensePaymentDueAlert = getLicensePaymentDueAlert(t, paymentDueDate);
	const manualLicenseAlert = getManualLicenseAlert(t, licenseType);
	const alerts: OrganizationAlert[] = [];

	if (outdatedTerminals && outdatedTerminals > 0) {
		alerts.push({
			title: `${t("modules.organization.field.outdated_terminals.title", {
				ns: "admin",
			})}: ${outdatedTerminals}`,
			type: "WARNING",
		});
	}
	if (testVersionTerminals && testVersionTerminals > 0) {
		alerts.push({
			title: `${t("modules.organization.field.test_version_terminals", {
				ns: "admin",
			})}: ${testVersionTerminals}`,
			type: "DANGER",
		});
	}

	if (licenseExpirationAlert) alerts.push(licenseExpirationAlert);
	if (licensePaymentDueAlert && isAdminMode) alerts.push(licensePaymentDueAlert);
	if (manualLicenseAlert && isAdminMode) alerts.push(manualLicenseAlert);

	if (abusedAccesses) {
		alerts.push({
			title: `${t("modules.organization.field.abused_access.title", {
				ns: "admin",
			})}: ${abusedAccesses}`,
			type: "DANGER",
		});
	}

	return alerts;
};
